import "vite/modulepreload-polyfill";
import "@virtualstate/navigation/polyfill";
import barba from "@barba/core";
import {
  useHydrate,
  useRefs,
  useTransition,
  createDevGrid,
  createBarbaScrollPersist,
} from "@/framework";
import * as pageTransitions from "~/transitions";
import { globals, components } from "~/components";

import Alpine from "alpinejs";
import { ITransitionData } from "@barba/core/dist/src/defs";

// window.Alpine = Alpine;

import bisForm from "@/components/bis-form";

Alpine.data("bisForm", bisForm);

Alpine.start();

// visit ?grid to show visual grid
createDevGrid({
  cols: 12,
  bleed: "var(--grid-bleed)",
  gap: "var(--grid-gap)",
});

let refs = useRefs({ asArray: true });
const globalComponents = useHydrate(globals);
const pageComponents = useHydrate(components);

// persist scroll position across navigation
createBarbaScrollPersist({ top: refs.announcementBar ? "1.5rem" : "0rem" });

// used for removing all "old" event listeners after page shift
// note: this is maybe only necessary when listening on window-events?
//       browsers seems to be smart enough to removeEventListeners automatically
//       when an element is removed from the dom(?)
let abortController: AbortController | null = null;
const refreshAbortController = () => {
  abortController?.abort();
  abortController = new AbortController();
};

barba.init({
  debug: location.origin.includes("127.0.0.1"),
  prevent: () => (window as any).Shopify.designMode,
  prefetchIgnore: "/cart",
  cacheIgnore: "/cart",
  transitions: useTransition({
    page: pageTransitions,
    global: {
      once() {
        refreshAbortController();
        globalComponents.hydrate(refs);
        pageComponents.hydrate(refs, { signal: abortController?.signal });
      },
      before() {
        window.dispatchEvent(new CustomEvent("window-navigation"));
        document.body.classList.add("has-scrolled");

        // remove jump when there's an announcement bar
        refs.siteHeader[0].style.transition = "transform 400ms";

        const logo = document.querySelector("#header-logo");
        if (logo) logo.removeAttribute("style");
        const logoSvg = document.querySelector("#header-logo-svg");
        if (logoSvg) logoSvg.removeAttribute("style");
      },
      leave() {
        refreshAbortController();
      },
      enter({ current }: ITransitionData) {
        refs = useRefs({ exclude: current.container, asArray: true });
        pageComponents.hydrate(refs, { signal: abortController?.signal });
      },
      after() {
        // remove jump when there's an announcement bar
        refs.siteHeader[0].style.removeProperty("transition");
      },
    },
  }),
});
